const serviceRoot = '/api/users/';

export const ProfileEndpoints = {
  getUserProfile: () => `${serviceRoot}getUserProfile`,
  saveUserProfile: () => `${serviceRoot}addUser`,
  updateUserProfile: () => `${serviceRoot}updateUserProfile`,
  getManageAccessUser: () => `${serviceRoot}getManageAccessUser`,
};
